<template>
  <v-card>
    <v-dialog v-model="confirmationdialog" width="640" >
      <v-card v-if="confirmationdialog" >
        <request-status :request="reqs.save" @ok="$emit('close')" />
        <v-card-title class='subtitle-1 overline' >
          Confirm exit
        </v-card-title>
        <v-card-text>
          Would you like to save your changes before closing?
        </v-card-text>
        <v-card-actions >
          <v-btn text @click="confirmationdialog=false" >Cancel</v-btn>
          <v-spacer/>
          <v-btn text color="primary" class="mr-3" @click="$emit('close')" >Close without saving</v-btn>
          <v-btn text outlined color="primary" @click="save()" >Save and close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar dense flat v-if="value" class="grey lighten-4" >

      <v-toolbar-title >Customize: {{ value.name }}</v-toolbar-title>
      <v-spacer/>
      <v-chip outlined color="primary" >{{ value.type }}</v-chip>
      <v-btn icon @click="confirmAndClose" ><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider/>
    <request-status :request="reqs.preview" @ok="previewOK" message200="Preview updated" />
    <request-status :request="reqs.save" @ok="saveOK" message200="Changes saved" />
    <v-card-text>
      <!-- <pre v-text="value" class="caption grey lighten-4 pa-3" /> -->
      <v-card-title>
        How would you like to send this notification?
        <v-spacer/>
        <v-btn
          :outlined="transport!=='Email'"
          @click="transport='Email'"
          color="primary" class="ml-4">
            <v-icon v-if="transport==='Email'" small >mdi-check</v-icon>
            Email</v-btn>
        <v-btn :outlined="transport!=='SMS'" @click="transport='SMS'" class="ml-4" color="primary">SMS</v-btn>
        <!-- <v-spacer/>
        <v-btn small icon @click="preview" ><v-icon>mdi-reload</v-icon></v-btn> -->
      </v-card-title>
      <v-divider/>
      <v-row>

        <v-col cols="7">
          <v-card height="100%" flat>
            <template v-if="transport === 'SMS'">
              <ag-textfield label="Message"
                v-model="smspayload.intro" />
              <v-checkbox v-model="smspayload.with_appt_link" label="Include link to appointment details" />
            </template>

            <template v-if="transport === 'Email'">

              <ag-textfield
                label="Subject line"
                class="mt-2"
                v-model="emailpayload.subject" />

              <v-stepper vertical v-model="emailstepper" class="mt-3">

                <v-stepper-step editable step="1" :complete="emailstepper > 1">
                  Introductory greeting
                  <small>A greeting and short summary note</small>
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-card>
                    <ag-textfield v-model="emailpayload.intro" @saved="preview" />
                    <v-card-actions>
                      <v-spacer />
                      <v-btn @click="emailstepper=2;preview()" color="primary">Next</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <v-stepper-step editable step="2" :complete="false">
                  Appointment information
                  <small>Customize how appointment information is included in your notifications</small>

                </v-stepper-step>
                <v-stepper-content step="2">

                  <appointment-information-form
                    v-model="emailpayload"
                    @change="debounceUpdate" />

                  <v-card-actions>
                    <v-btn @click="emailstepper=1" text>Previous</v-btn>
                    <v-spacer />
                    <v-btn @click="emailstepper=3" color="primary">Next</v-btn>
                  </v-card-actions>

                </v-stepper-content>

                <v-stepper-step editable step="3" :complete="false">
                  Sign off text
                  <small>Last paragram </small>
                </v-stepper-step>

                <v-stepper-content step="3">
                  <v-card>
                    <ag-textfield v-model="emailpayload.outro" @saved="preview" />
                    <v-card-actions>
                      <v-btn @click="emailstepper=2" text>Previous</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <!-- <v-btn class="ml-3" color="primary" >Save</v-btn> -->
              </v-stepper>
            </template>

            <v-card-actions class="grey lighten-2">
              <v-spacer />
              <v-btn
                @click="save"
                :loading="reqs.preview.loading" color="primary" class="mr-2">Save</v-btn>
            </v-card-actions>

          </v-card>
        </v-col>

        <!-- preview -->
        <v-col cols="5">
          <v-card class="mt-2" tile height="100%" style="position:sticky;">

            <v-overlay :value="reqs.preview.loading" absolute light :opacity="0.2">
              <v-progress-circular indeterminate class="mt-5 mb-3" size="120" color="amber" /><br />
              Updating preview
            </v-overlay>
            <v-card tile class="ma-3 mb-0" >
              <v-system-bar class="overline" >
                Using this appointment as an example:
              </v-system-bar>
              <appointment-list-item v-if="exampleAppt && exampleAppt.id" :item="exampleAppt">
                <v-list-item-action slot="list-item-action">
                  <v-btn @click="preview" small icon ><v-icon>mdi-replay</v-icon></v-btn>
                </v-list-item-action>
              </appointment-list-item>
            </v-card>

            <v-card-title class='overline grey lighten-4 py-1'>
              {{transport}} preview:
            </v-card-title>

            <v-card-text v-if="transport === 'Email'">
              <div class="grey lighten-4 pa-3 elevation-4">
                <strong>Subject:</strong><br/>
                {{emailsubjectpreview}}
                <hr class="my-3" />
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="emailpreview" />
              </div>
              <!-- <pre v-text="notificationpreview" class="caption grey lighten-4 pa-3" />
              <pre v-text="emailpayload" class="caption grey lighten-4 pa-3" /> -->
              <!--<pre v-text="payload" class="caption grey lighten-4 pa-3" /> -->
            </v-card-text>
            <v-card-text v-else>
              <pre style="white-space: pre-wrap"
                v-if="shortmessagepreview"
                v-text="shortmessagepreview"
                class="caption pa-2 grey lighten-4" />
              <div v-else>
                <v-btn text small block
                  @click="preview" >Click to load preview</v-btn>
              </div>
            </v-card-text>

          </v-card>
        </v-col>
      </v-row>

    </v-card-text>
    <!-- <v-btn @click="setconfig" >Set payload</v-btn>

    email config:
    <pre v-text="emailpayload" class="caption pa-2 grey lighten-4" />
    remote config:
    <pre v-text="remoteEmailConfig" class="caption pa-2 grey lighten-4" /> -->
  </v-card>
</template>
<script>
import AgTextfield from './customize/AgTextfield.vue'
import AppointmentListItem from '@/components/listitems/AppointmentListItem.vue'
import AppointmentInformationForm from './customize/AppointmentInformationForm.vue'
import { marked } from 'marked'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'NotificationConfiguration',
  components: { AgTextfield, AppointmentInformationForm, AppointmentListItem },
  props: {
    value: { type: Object },
    slug: { type: String, required: true },
    prefix: { type: String },
    items: { type: Array, default: () => { return [] }}
  },
  data () {
    return {
      confirmationdialog: false,
      timeout: null,
      dirty: false,
      inited: false,
      transport: 'Email',
      smspayload: {
        // 'A reminder for your appointment with {{appointment.space_name}} on {{appointment.starttime_formatted.client_zoned_date_formatted}} {{appointment.starttime_formatted.client_zoned_time_formatted}}'
        intro: null,
        with_appt_link: false
      },
      emailpayload: {
        subject: 'Confirmed: Your appointment with {{appointment.practitioner_name}} at {{appointment.space_name}}',
        intro: `Hi {{client.first_name}},

This confirms your appointment with {{appointment.practitioner_name}} at {{appointment.space_name}}`,
        with_product: true,
        with_when: true,
        with_where: true,
        where_address_name: true,
        where_address_address: true,
        where_address_link: true,
        where_address_notes: true,

        with_appt_link: true,
        with_form_link: true,
        outro: 'Kind regards, {{me.first_name}}'
      },
      reqs: {
        preview: {
          resource: 'ag.practitioner',
          extra: 'actions/customize_notification',
          loading: false
        },
        save: {
          resource: 'ag.practitioner',
          extra: 'actions/customize_notification',
          loading: false
        }
      },
      emailstepper: "1"
    }
  },
  mounted () {
    if (this.value && this.value.type) {
      this.transport = this.value.type
    }
    this.preview()
  },
  watch: {
    transport () { this.preview() }
  },
  computed: {
    ...mapGetters ('identity', ['meId']),
    basepayload () {
      return {
        preferred_transport: this.transport,
        practitioner: this.meId,
        notification_id: this.notificationId,
        preview: false
      }
    },
    payload () {
      let payload = {}
      if (this.transport === 'Email') {
        payload = {...this.basepayload, ...this.emailpayload }
      } else {
        payload = {...this.basepayload, ...this.smspayload }
      }
      return payload
    },
    notificationId () {
      return this.getObjectPath(this.value, 'slug')
    },
    exampleAppt () {
      return this.getObjectPath(this.reqs.preview, 'result.notification.example_appointment', {})
    },
    notificationpreview () {
      return this.getObjectPath(this.reqs.preview, 'result.notification', {})
    },
    emailpreview () {
      let msg = this.getObjectPath(this.notificationpreview, 'preview_formatted', '')
      if (msg) {
        return this.markdown(msg)
      }
      return ''
    },
    emailsubjectpreview () {
      return this.getObjectPath(this.notificationpreview, 'preview_subject_formatted', '')
    },
    shortmessagepreview () {
      return this.getObjectPath(this.notificationpreview, 'short_message', '')
    },
    remoteEmailConfig () {
      return this.getObjectPath(this.reqs, 'preview.result.notification.config.Email')
    },
    remoteSMSConfig () {
      return this.getObjectPath(this.reqs, 'preview.result.notification.config.SMS')
    }
  },
  methods: {
    debounceUpdate () {
      this.dirty = true
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      let vm = this
      this.timeout = window.setTimeout(() => {
        vm.preview()
      }, 1000)
    },
    preview () {
      // /api/v3/practitioner/practitioners/1/actions/customize_notification/
      if (this.meId) {
        let payload = this.payload
        this.reqs.preview.resourceId = this.meId
        this.reqs.preview.method = 'post'
        this.reqs.preview.data = payload
        this.reqs.preview.data.preview = true
        this.$request('save', this.reqs.preview)
      }
    },
    previewOK () {
      if (!this.inited) {
        this.setconfig()
      }
      this.inited = true
    },
    save () {
      this.reqs.save.resourceId = this.meId
      this.reqs.save.method = 'post'
      this.reqs.save.data = this.payload
      this.reqs.save.data.preview = false
      this.$request('save', this.reqs.save)
    },
    saveOK () {
      this.dirty = false
      this.preview()
    },
    setconfig () {
      // let type = this.getObjectPath(this.reqs, 'preview.result.notification.type')
      let emailconfig = this.remoteEmailConfig
      if (emailconfig) { Vue.set(this, 'emailpayload', emailconfig) }

      let smsconfig = this.remoteSMSConfig
      if (smsconfig) { Vue.set(this, 'smspayload', smsconfig) }


    },
    markdown (text) {
      return marked(text)
    },
    confirmAndClose () {
      if (this.dirty) {
        this.confirmationdialog = true
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>
